import Vue from "vue";

export default {
  async list() {
    const response = await Vue.axios.get(`workspaces`);
    return response.data;
  },
  async get(id) {
    const response = await Vue.axios.get(`workspaces/${id}`);
    return response.data;
  },
  async create(data) {
    const response = await Vue.axios.post(`workspaces`, data);
    return response.data;
  },
  async update(id, data) {
    const response = await Vue.axios.post(`workspaces/${id}`, data);
    return response.data;
  },
  async delete(id) {
    const response = await Vue.axios.delete(`workspaces/${id}`);
    return response.data;
  }
};
